// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/817946b6d084a01b5dc5.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"0af4ea2a8e82fbd6e7aa","191":"24343762fba554456ca7","192":"ee98f465b97484c6a46d"}[chunkId] + ".chunk.js";
};